import {AntdConfig, AntdWidgets} from "@react-awesome-query-builder/antd";
import '@react-awesome-query-builder/ui/css/styles.css';
import {UseGet, UsePut} from "../../../hooks/http";
import {Campaign, CustomDatetime} from "./widgets";
import {GetDefinition} from "./hooks";


const {FieldCascader, FieldSelect} = AntdWidgets;
const InitialConfig = AntdConfig;


export const getConsentTypes = async (audience, labelProp = 'title') => {
    const output = {
        values : [],
        hasMore: false,
    }


    const request = await UsePut(
        `/audiences/${audience?._id?.$oid}/consents/types/get`,
        {data: {limit: 0, offset: 0}, toArray: true, propLabel: 'name', keyLabel: 'slug'},
    );

    if (request?.length > 0) {
        request.map(type => {
            output.values.push({[labelProp]: type.name, value: type.slug})
        })
    }

    return output
}

export default ({fields, audience}) => {


    const getJourneys = async () => {
        return {
            values : await UsePut(
                '/journeys/get',
                {data: {limit: 0, offset: 0}, toArray: true, propLabel: 'title', keyLabel: 'title'},
            ),
            hasMore: false,
        }
    }


    const getStatus = async () => {

        const request = await UseGet(
            '/status/get',
            {toArray: true},
        )

        return {
            values : request,
            hasMore: false,
        }
    }


    const getDynamicFields = (target) => {
        const output = {}
        const excluded = ['id_action', 'id_journey', 'status', 'channel', 'id_campaign', 'id_component']
        if (typeof fields[target] === 'object' && Object.keys(fields[target]).length > 0) {
            Object.keys(fields[target]).map(property => {
                if (!excluded.includes(property)) {
                    output[property] = GetDefinition(fields[target][property])
                }
            })
        }

        return output;
    }


    let configFields = {
        History : {
            label    : "History Data",
            fieldName: "History",
            type     : "!struct",
            subfields: {
                fields     : {
                    label    : "Fields",
                    type     : "!struct",
                    subfields: {
                        ...getDynamicFields('history'),
                        created_at: GetDefinition({
                            name      : 'created_at',
                            field_type: 'date',
                            is_filter : 'on'
                        }),
                    }
                },
                id_journey : {
                    operators    : ['select_equals', 'select_not_equals'],
                    valueSources : ["value"],
                    label        : "Journey",
                    type         : "select",
                    fieldSettings: {
                        asyncFetch       : getJourneys,
                        useAsyncSearch   : true,
                        useLoadMore      : true,
                        forceAsyncSearch : false,
                        allowCustomValues: false
                    }
                },
                status     : {
                    type         : "select",
                    label        : "Status",
                    valueSources : ["value"],
                    operators    : ['select_equals', 'select_not_equals'],
                    fieldSettings: {
                        asyncFetch       : getStatus,
                        useAsyncSearch   : true,
                        useLoadMore      : true,
                        forceAsyncSearch : false,
                        allowCustomValues: false
                    }
                },
                channel    : {
                    type         : "select",
                    label        : "Channel",
                    valueSources : ["value"],
                    operators    : ['select_equals', 'select_not_equals'],
                    fieldSettings: {
                        listValues: [
                            {title: "Sms", value: "sms"},
                            {title: "Sftp", value: "sftp"},
                            {title: "Email", value: "email"},
                            {title: "Landing", value: "landing"},
                            {title: "Whatsapp", value: "whatsapp"},
                            {title: "Webservice", value: "webservice"},
                        ],
                    }
                },
                id_campaign: {
                    label       : 'Campaign',
                    type        : 'campaign',
                    valueSources: ['value'],
                },
            },
        },
        Audience: {
            label    : "Audience Data",
            fieldName: "Audience",
            type     : "!struct",
            subfields: {
                ...getDynamicFields('audience'),
                mobile_provider: GetDefinition({
                    name      : 'mobile_provider',
                    field_type: 'string',
                    is_filter : 'on'
                }),
                created_at     : GetDefinition({
                    name      : 'created_at',
                    field_type: 'date',
                    is_filter : 'on'
                }),
            }
        }
    }

    if (audience?.Account?.Plan?.features?.use_consents === "on") {
        configFields['Consents'] = {
            label    : "Consents",
            fieldName: "consents",
            type     : "!struct",
            subfields: {
                scope      : {
                    valueSources : ["value"],
                    operators    : ['multiselect_contains'],
                    label        : "Scope",
                    type         : "multiselect",
                    fieldSettings: {
                        asyncFetch       : () => getConsentTypes(audience),
                        useAsyncSearch   : true,
                        useLoadMore      : true,
                        forceAsyncSearch : false,
                        allowCustomValues: false
                    }
                },
                device_type: {
                    type         : "select",
                    label        : "Device type",
                    valueSources : ["value"],
                    operators    : ['select_equals'],
                    fieldSettings: {
                        listValues: [
                            {title: "Mobile phone", value: "mobile_phone"},
                            {title: "Email address", value: "email_address"}
                        ],
                    }
                },
            }
        }

    }


    return {
        ...InitialConfig,
        conjunctions: {
            AND: {
                ...InitialConfig.conjunctions.AND
            }
        },
        operators   : {
            ...InitialConfig.operators,
            is_empty    : {
                ...InitialConfig.operators.is_empty,
                mongoFormatOp: (field, operator) => {
                    return {[field]: {$exists: false}}
                }
            },
            is_not_empty: {
                ...InitialConfig.operators.is_not_empty,
                mongoFormatOp: (field, operator) => {
                    return {[field]: {$exists: true}}
                }
            }
        },
        types       : {
            ...InitialConfig.types,
            campaign: {
                defaultOperator: "equal",
                valueSources   : ['value'],
                widgets        : {
                    campaign: {
                        operators  : [
                            "equal",
                            "not_equal",
                            "is_empty",
                            "is_not_empty",
                        ],
                        widgetProps: {
                            valueSources: ['value'],
                        },
                        opProps    : {
                            mainWidget: 'search',
                        }
                    },
                },
            },
        },
        widgets     : {
            ...InitialConfig.widgets,
            campaign: {
                type    : 'campaign',
                valueSrc: 'value',
                factory : (props) => (<Campaign {...props} />),
            },
            datetime: {
                type            : "datetime",
                jsType          : "object",
                valueSrc        : "value",
                factory         : (props) => <CustomDatetime {...props} />,
                valueLabel      : "Choose an option",
                valuePlaceholder: "Choose an option",
            }
        },
        settings    : {
            ...InitialConfig.settings,
            renderField                : (props) => <FieldCascader {...props} />,
            renderOperator             : (props) => <FieldSelect {...props} />,
            renderFunc                 : (props) => <FieldSelect {...props} />,
            canReorder                 : true,
            canRegroup                 : true,
            maxNesting                 : 1,
            showLabels                 : false,
            showNot                    : false,
            showCombinatorsBetweenRules: false,
            setOpOnChangeField         : ['keep', 'default'],
            customFieldSelectProps     : {
                showSearch: true
            },
        },
        fields      : configFields,
    };


};